import {createFileRoute} from '@tanstack/react-router'
import MexicanosView from "../../../mexicanos/MexicanosView.tsx";

export const Route = createFileRoute('/_app/mexicanos/$mexicano_uid/$page')({
    component: RouteComponent,
})

function RouteComponent() {
    return <MexicanosView />
}
